var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"from-google"},[_c('p',{staticStyle:{"color":"green","opacity":"0.8","font-size":"18px"}},[_vm._v(_vm._s(_vm.status))])])}
var staticRenderFns = []

export { render, staticRenderFns }